/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */
import React from "react"
import {
    Label,
    Icon,
    Button,
    Column,
    Row,
    ContentSection,
    FooterSection,
    Step,
    TitleSection,
    ModalTitle,
    ErrorRotate
} from "trux"
import { PreviewVideo } from "./PreviewVideo"
import { PieTimer } from "./PieTimer"
import PropTypes from "prop-types"

export const StepReview = (props) => {
    return (
        <Step name={props.name}>
            <TitleSection onCloseClick={props.close}>
                <ModalTitle content={props.title} />
            </TitleSection>
            <ContentSection>
                <div className="preview-video-container">
                    <PreviewVideo
                        game={props.game}
                        moment={props.moment}
                        teamName={props.team.name}
                        gameId={props.game.game_id}
                        marginBottom={4}
                        start={props.start}
                        end={props.end}
                        onVideoUpdate={props.onVideoUpdate}
                    />
                    <PieTimer
                        height="30"
                        width="30"
                        start={props.start}
                        end={props.end}
                        current={props.currentTime}
                    />
                </div>

                <Row marginBottom="4">
                    <Column span="3">
                        <Label bold content="Moment:" />
                    </Column>
                    <Column span="9">
                        <Label
                            content={`Start: ${formatTime(
                                props.momentStart + props.start
                            )}`}
                        />
                        <Label
                            content={`Length: ${Math.floor(
                                props.end - props.start
                            )}s`}
                        />
                    </Column>
                </Row>
                <Row marginBottom="4">
                    <Column span="3">
                        <Label bold content="Location:" />
                    </Column>
                    <Column span="9">
                        <Label content={props.reviewLocation} />
                    </Column>
                </Row>
                <Row marginBottom="4">
                    <Column span="3">
                        <Label bold content="Playlists:" />
                    </Column>
                    <Column span="9">
                        <Label content={props.playlistText} />
                    </Column>
                </Row>
                <Row marginBottom="4">
                    <Column span="3">
                        <Label bold content="Players:" />
                    </Column>
                    <Column span="9">
                        <Label content={props.reviewPlayers} />
                    </Column>
                </Row>
                {props.advancedEditor && (
                    <Row marginBottom="4">
                        <Column span="3">
                            <Label bold content="Client Side Panning:" />
                        </Column>
                        <Column span="9">
                            <textarea
                                value={props.csp}
                                onChange={props.onCSPChange}
                            />
                        </Column>
                    </Row>
                )}
            </ContentSection>
            <ErrorRotate />
            <FooterSection>
                <Row center alignItems="flex-start">
                    {props.onBack && (
                        <Button
                            icon={Icon.Type.CheveronLeft}
                            onClick={props.onBack}
                            marginRight="2"
                            trkAction="Review Back Pressed"
                        />
                    )}
                    <Button
                        primary
                        span="1"
                        content={props.nextText}
                        onClick={props.onNext}
                        trkAction="Review Next Pressed"
                    />
                </Row>
            </FooterSection>
        </Step>
    )
}

function formatTime(time) {
    let min = Math.floor(time / 60)
    let sec = Math.floor(time - min * 60)

    if (min < 10) {
        min = "0" + min
    }
    if (sec < 10) {
        sec = "0" + sec
    }
    return `${min}:${sec}`
}

StepReview.protoTypes = {
    name: PropTypes.string.isRequired,
    moment: PropTypes.object.isRequired,
    team: PropTypes.object.isRequired,
    game: PropTypes.object.isRequired,
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    momentStart: PropTypes.number.isRequired,
    onVideoUpdate: PropTypes.func.isRequired,
    reviewLocation: PropTypes.string.isRequired,
    playlistText: PropTypes.string.isRequired,
    reviewPlayers: PropTypes.string.isRequired,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    nextText: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    advancedEditor: PropTypes.bool,
}
